import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useEventActionBarStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    width: 'fit-content',
  },
  selectedCount: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
    whiteSpace: 'nowrap',
  },
  actionButton: {
    color: tokens.colorBrandForegroundLink,
  },
});
